import React, { forwardRef, Ref } from 'react';
import { StreamEdit } from './stream-edit';
import { StreamViewModel } from './stream-models';

interface Props {
  model: StreamViewModel;
}
export interface StreamAddFormRef {
  submitStream: () => Promise<void>;
}
export const AddStream = forwardRef((props: Props, ref: Ref<StreamAddFormRef>) => {
  const { model } = props;

  return (
    <div className="mk-add-stream">
      <StreamEdit ref={ref} model={model} />
    </div>
  );
});

AddStream.displayName = 'AddStream';
